<template>
  <v-main>
    <v-container fluid>
      <router-view :key="$route.path" />
    </v-container>
    <v-snackbars
      :objects.sync="toastOjects"
      bottom
      left
    >
      <template v-slot:action="{ close }">
        <v-icon
          dark
          @click="close()"
        >
          mdi-close-circle-outline
        </v-icon>
      </template>
    </v-snackbars>
  </v-main>
</template>

<script>
  import VSnackbars from 'v-snackbars'
  export default {
    name: 'DefaultView',
    components: {
      'v-snackbars': VSnackbars,
    },
    computed: {
      toastOjects: {
        get () {
          return this.$store.state.toast.objects
        },
        set (val) {
          this.$store.dispatch('toast/update', val)
        },
      },
    },

  }
</script>
